import {Card, IconButton, Stack, Typography} from '@mui/material';
import React from 'react';

import {Indexation} from '@store/settings/indexation';

import {BlackClock, GroupAction} from '@icons/index';
import dayjs from '@utils/dayjs.utils';

import {Colors} from '@constants/colors.constants';

interface IndexationInfosCardProps {
  indexation: Indexation;
  onShowDetails?: () => void;
  onShowHistory?: () => void;
  onClick?: () => void;
}

const IndexationInfosCard = (props: IndexationInfosCardProps) => {
  const {indexation, onShowDetails, onShowHistory, onClick} = props;

  const rate = indexation.currentIndexationRate;
  const period = rate?.fromDate
    ? dayjs(rate.fromDate).format('MMMM YYYY')
    : undefined;

  return (
    <Card
      onClick={onClick}
      sx={{cursor: onClick ? 'pointer' : undefined}}
      elevation={0}>
      <Stack p="10px" bgcolor={Colors.background} borderRadius="4px" spacing={0.5}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} mr="-5px">
          <Typography fontSize={16} fontWeight="700">
            {indexation.name}
          </Typography>
          <Stack direction="row" alignItems="center">
            <IconButton
              onClick={(evt) => {
                evt.stopPropagation();
                onShowDetails?.();
              }}>
              <GroupAction style={{height: 14, width: 14}}/>
            </IconButton>
            <IconButton
              sx={{mr: '-7px'}}
              onClick={(evt) => {
                evt.stopPropagation();
                onShowHistory?.();
              }}>
              <BlackClock style={{height: 14, width: 14}}/>
            </IconButton>
          </Stack>
        </Stack>
        <Typography fontSize={14} color={Colors.textWithOpacity} fontWeight="400">
          {indexation.code}
        </Typography>
        {rate && (
          <Stack direction="row" justifyContent="space-between">
            <Typography fontSize={14} color={Colors.textWithOpacity} fontWeight="400">
              {`${rate.rateInPercent}%`}
            </Typography>
            <Typography fontSize={14} color={Colors.textWithOpacity} fontWeight="400">
              {period}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Card>
  );
};

export default IndexationInfosCard;